import { render, staticRenderFns } from "./ModalAddCertificate.vue?vue&type=template&id=25e1745a&scoped=true"
import script from "./ModalAddCertificate.vue?vue&type=script&lang=js"
export * from "./ModalAddCertificate.vue?vue&type=script&lang=js"
import style0 from "./ModalAddCertificate.vue?vue&type=style&index=0&id=25e1745a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e1745a",
  null
  
)

export default component.exports